import {useEffect, useMemo, useState} from "react";

export default function usePersistState<T>(
    initial_value: T,
    id: string
): [T, (new_state: T) => void] {
    const storageKey = `state:${id}`;

    const _initial_value = useMemo(() => {
        if (typeof window === "undefined") {
            return initial_value;
        }

        try {
            const local_storage_value_str = localStorage.getItem(storageKey);
            if (!local_storage_value_str || local_storage_value_str === "undefined") {
                localStorage.removeItem(storageKey);
                return initial_value;
            }

            return JSON.parse(local_storage_value_str) as T;
        } catch {
            localStorage.removeItem(storageKey);
            return initial_value;
        }
    }, [initial_value, storageKey]);

    const [state, setState] = useState<T>(_initial_value);

    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }

        if (state === undefined) {
            localStorage.removeItem(storageKey);
            return;
        }

        const state_str = JSON.stringify(state);
        localStorage.setItem(storageKey, state_str);
    }, [state, storageKey]);

    return [state, setState];
}
